import { useEffect, useState } from 'react';
import { UbicationsAPI } from '../../../../../services/external/APIs/ubications/UbicationsAPI';
import { Ubication } from './ubication';

interface Props {
    name: string;
    label: string;
    value: number;
    required: boolean;
    disable?: boolean;
    onChange: (name: string, value: string) => void;
}

export default function UbicationSelector({
    name,
    value,
    label,
    required,
    onChange,
    disable = false,
}: Props) {
    const onFocus = (event: React.FocusEvent<HTMLSelectElement>) => {
        event.target.classList.add('touched');
    };

    const [ubications, setUbications] = useState<Ubication[]>([]);

    useEffect(() => {
        UbicationsAPI.Get().then((response) => setUbications(response));
    }, []);

    return (
        <div>
            <label htmlFor={name} key={`label-${name}`} className='form-label'>
                {label}
            </label>
            <select
                disabled={disable}
                className='form-control form-select text-black'
                id={name}
                key={name}
                name={name}
                value={value}
                required={required}
                onChange={(e) => onChange(name, e.target.value)}
                onFocus={onFocus}
            >
                <option value=''>- Seleccione -</option>
                {ubications.map((familyRelationshipType) => (
                    <option
                        value={familyRelationshipType.id}
                        key={familyRelationshipType.id}
                    >
                        {familyRelationshipType.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
